import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  urbanProducts: null,
  urbanRequestCategories: [],
  urbanPenaltiesTypes: [],
  urbanPenalties: null,
  urbanPenaltiesCount: 0,
  urbanPenaltiesLoaded: false,
  currentUrbanRequest: null,
  urbanRequests: null,
  urbanRequestsCount: 0,
  urbanRequestStats: {
    totalRequests: 0,
    draftRequests: 0,
    revisionRequests: 0,
    approvedRequests: 0,
    paidRequests: 0,
    rejectedRequests: 0,
    archivedRequests: 0,
    certificatedRequests: 0,
    uncertificatedRequests: 0,
    createdRequests: 0,
  },
  searchResults: null,
  isSearching: false,
  isLoading: false,
};

const slice = createSlice({
  name: "urbin",
  initialState: initialState,
  reducers: {
    setUrbinState: (state, action) => {
      Object.keys(action.payload).forEach((k) => {
        state[k] = action.payload[k];
      });
    },
  },
});

export const reducer = slice.reducer;

export const setUrbinState = (data) => async (dispatch) => {
  dispatch(slice.actions.setUrbinState(data));
};
